const canvas = document.createElement('canvas')
// 创建用于绘制的基础canvas画布
function createBaseCanvas(scale, { width, height }) {
  canvas.width = width * scale
  canvas.height = height * scale
  return canvas
}

// 生成快照
function convertToImage(container, options = {scale:2}) {
  // 设置放大倍数
  var scale = options.scale
  // 创建用于绘制的基础canvas画布
  // 传入节点原始宽高
  const width = container.offsetWidth
  const height = container.offsetHeight
  const canvas = createBaseCanvas(scale, { width, height })

  // html2canvas配置项
  const ops = {
    dpi: window.devicePixelRatio * scale,
    scale,
    width:width,
    height:height,
    canvas,
    logging: false,
    useCORS: true,
    allowTaint: false,
    ...options,
  }

  return html2canvas(container, ops).then((canvas) => {
    return canvas
  })
}

export default convertToImage
